import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import { WideArrowUpward, WideArrowDownward, Close12 } from '../../icons';
import { useIsInBottomSheet } from '../BottomSheet/BottomSheet';
import { BottomSheetContentLayout } from '../BottomSheet/BottomSheetContentLayout';
import { Button } from '../Button';
import { ChipButton } from '../ChipButton';
import { CloseButton } from '../CloseButton';
import { useOverlayContext } from '../OverlayContext';
import { Popover } from '../Popover';
import { TextButton } from '../TextButton';
import { Typography } from '../Typography';
import styles from './FilterPicker.module.scss';
export const FilterPicker = (props)=>{
    const { children, title, label, removable, disableApply, headerContent, startOpen = false, popoverWidth, hasError, onRemove, onClose, onApply, highlightTrigger, type = 'chip', testId } = props;
    const isInBottomSheet = useIsInBottomSheet();
    const { popBottomSheetPage } = useOverlayContext();
    const anchorElRef = useRef(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const [isHighlighted, setIsHilighted] = useState(highlightTrigger);
    function closePopover(options) {
        setAnchorEl(null);
        setTimeout(()=>{
            onClose(options);
        }, 100);
    }
    function handleApply() {
        if (isInBottomSheet) {
            popBottomSheetPage();
        }
        onApply();
        closePopover({
            revert: false
        });
    }
    useEffect(()=>{
        if (anchorEl) {
            setIsHilighted(true);
        } else {
            setIsHilighted(highlightTrigger);
        }
    }, [
        anchorEl,
        highlightTrigger
    ]);
    useEffect(()=>{
        if (startOpen && anchorElRef.current) {
            setAnchorEl(anchorElRef.current);
        }
    }, []);
    return isInBottomSheet ? /*#__PURE__*/ _jsx(BottomSheetContentLayout, {
        header: {
            title,
            subtitle: headerContent,
            gutter: 'm'
        },
        contentGutter: "m",
        footer: {
            primaryAction: {
                text: 'Apply',
                onClick: handleApply,
                disabled: disableApply,
                testId: "".concat(testId, "-apply")
            }
        },
        children: /*#__PURE__*/ _jsx("div", {
            className: styles.filters,
            children: children
        })
    }) : /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.chip,
                "data-testid": testId,
                children: [
                    type === 'chip' && /*#__PURE__*/ _jsx(ChipButton, {
                        ref: anchorElRef,
                        testId: "".concat(testId, "-trigger"),
                        suffixIcon: anchorEl ? /*#__PURE__*/ _jsx(WideArrowUpward, {}) : /*#__PURE__*/ _jsx(WideArrowDownward, {}),
                        onClick: (e)=>setAnchorEl(e.currentTarget),
                        highlight: isHighlighted,
                        children: label
                    }),
                    type === 'button' && /*#__PURE__*/ _jsx(Button, {
                        skin: "primaryOutline",
                        ref: anchorElRef,
                        testId: "".concat(testId, "-trigger"),
                        onClick: (e)=>setAnchorEl(e.currentTarget),
                        highlight: isHighlighted,
                        prefixIcon: props.type === 'button' ? props.prefixIcon : undefined,
                        children: props.type === 'button' || props.type === 'textButton' ? props.buttonTitle || title : title
                    }),
                    type === 'textButton' && /*#__PURE__*/ _jsx(TextButton, {
                        type: "button",
                        testId: "".concat(testId, "-trigger"),
                        onClick: (e)=>setAnchorEl(e.currentTarget),
                        highlight: isHighlighted,
                        underline: "none",
                        skin: hasError ? 'error' : 'primary',
                        "aria-invalid": hasError,
                        children: props.type === 'button' || props.type === 'textButton' ? props.buttonTitle || title : title
                    }),
                    removable && /*#__PURE__*/ _jsx("button", {
                        className: styles.remove,
                        "data-testid": "".concat(testId, "-remove"),
                        onClick: onRemove,
                        children: /*#__PURE__*/ _jsx(Close12, {
                            height: 6,
                            width: 6
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Popover, {
                open: !!anchorEl,
                anchorEl: anchorEl,
                onClose: ()=>closePopover({
                        revert: true
                    }),
                children: /*#__PURE__*/ _jsxs("div", {
                    className: styles.popover,
                    style: {
                        width: popoverWidth
                    },
                    "data-testid": "".concat(testId, "-popover"),
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: styles.closeButtonContainer,
                            children: /*#__PURE__*/ _jsx(CloseButton, {
                                testId: "".concat(testId, "-close"),
                                size: "small",
                                onClick: ()=>{
                                    closePopover({
                                        revert: true
                                    });
                                }
                            })
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsx(Typography, {
                                    variant: "paragraph1",
                                    skin: "secondary",
                                    testId: "".concat(testId, "-title"),
                                    children: title
                                }),
                                headerContent
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: styles.filters,
                            children: children
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: styles.footer,
                            children: /*#__PURE__*/ _jsx(Button, {
                                testId: "".concat(testId, "-apply"),
                                fluid: true,
                                disabled: disableApply,
                                onClick: handleApply,
                                children: "Apply"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
